import { notify } from '@billy/design-system'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { NotificationKeys } from '../../../../../enums/notificationKeys'
import { deleteProfilePic } from '../../../query-api'

interface UseDeleteProfilePicProps {
  onSuccess?: () => void
  onError?: () => void
}

export const useDeleteProfilePic = ({ onSuccess, onError }: UseDeleteProfilePicProps = {}) => {
  const { t } = useTranslation()

  const { mutate: deleteProfilePicture, isLoading: isProcessing } = useMutation(deleteProfilePic, {
    onError: () => {
      notify({
        id: NotificationKeys.ProfilePicDeleteError,
        message: t('error_saving'),
        variant: 'error',
      })
      onError?.()
    },
    onSuccess: () => {
      notify({
        id: NotificationKeys.ProfilePicDeleteSuccess,
        message: t('settings.user.profile_pic_delete_success'),
        variant: 'success',
      })
      onSuccess?.()
    },
  })

  return { deleteProfilePicture, isProcessing }
}
